export enum BankMatchesType {
  Positive = 'positive',
  Negative = 'negative',
}
